import { useQuery } from 'react-query'
import ManagementService from '../coreApi'
import { IUserRecord } from '../types/feed'
import useUserId from './useUserId'

const useUserRecords = () => {
  const userId = useUserId()
  return useQuery<IUserRecord[], Error>(
    ['userRecords', userId],
    () => ManagementService.getUserRecords(userId),
    {
      enabled: !!userId,
    },
  )
}

export default useUserRecords
